import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

interface LayoutProps {
  children: React.ReactNode;
  userType: "jobseeker" | "hr" | "admin";
}

/*
 * Post-auth shell. Sidebar (240px), Header (72px), main content area.
 * Cream background, no animated blobs.
 */
const Layout: React.FC<LayoutProps> = ({ children, userType }) => {
  return (
    <div className="flex min-h-screen w-full overflow-x-hidden bg-cream">
      <Sidebar userType={userType} />
      <div className="flex flex-1 flex-col min-w-0 overflow-x-hidden">
        <Header userType={userType} />
        <div className="flex flex-1 overflow-visible">
          <main className="flex-1 overflow-y-auto overflow-x-visible px-12 py-12">
            <div className="mx-auto max-w-6xl space-y-10 overflow-visible">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
